export enum SearchSelectField {
  id = 'id',
  status = 'status',
  ogaStatus = 'ogaStatus',
  ogaStatusInNationalLang = 'ogaStatusInNationalLang',
  licenseType = 'licenseType',
  requestNumber = 'requestNumber',
  requestDate = 'requestDate',
}
